<template>
  <slot :count="pendingApprovablesCount" :loading="loading"></slot>
</template>

<script setup lang="ts">
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import { ref, watch } from 'vue'

const pendingApprovablesCount = ref(0)
const currentPage = ref(1)

const { result, loading } = useQuery(
  gql`
    query CountApprovalApprovables($page: Int, $accounts: [ID!], $requiresActionUsers: [ID!]) {
      approvalApprovables(
        page: $page
        accounts: $accounts
        requiresActionUsers: $requiresActionUsers
      ) {
        paginatorInfo {
          total
        }
      }
    }
  `,
  () => ({
    accounts: [currentAccount.globalId],
    requiresActionUsers: [currentUser.globalId],
    page: currentPage.value,
  }),
  {
    clientId: 'publicApi',
    debounce: 100,
  },
)

watch(result, (newValue) => {
  if (newValue && newValue?.approvalApprovables?.paginatorInfo?.total !== undefined) {
    pendingApprovablesCount.value = newValue.approvalApprovables.paginatorInfo.total
  }
})
</script>
